import '.gg{z-index:4;}.ssr-plugin'
import '.n{position:relative;}.ssr-plugin'
import '.j0{width:240px;}.ssr-plugin'
import '.fj{padding:8px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.f6{gap:2px;}.ssr-plugin'
import '.fk{outline:none;}.ssr-plugin'
import { useState, useMemo } from 'react'
import { colors } from '../../tokens/colors.js'
import { shadows } from '../../utils/shadows.js'
import { radius } from '../../utils/radius.js'
import { DatePicker } from './DatePicker.js'
import { DateTimePicker } from './DateTimePicker.js'
import { Overlay } from '../Overlay/index.js'
import { styled } from 'inlines'

type CalendarProps = {
  children: React.ReactNode
  variant: 'date' | 'date-time'
  value?: number // milliseconds elapsed since the epoch (so like Date.now())
  onChange: (value: number) => void
  setOpen?: (open: boolean) => void
  selectableRange?: {
    min?: number | Date
    max?: number | Date
  }
}

export const Calendar = ({
  children,
  variant,
  value: msValue,
  onChange,
  setOpen, // Default to a no-op function
  selectableRange,
}: CalendarProps) => {
  const value = useMemo(
    () => (msValue ? new Date(msValue) : undefined),
    [msValue],
  )

  return (
    <Overlay
      scrollableParent
      onClose={() => setOpen?.(false)}
      onOpen={() => setOpen?.(true)}
    >
      <Overlay.Trigger>{children}</Overlay.Trigger>
      <Overlay.Content>
        <div className="gg n j0 fj a i f6 fk"
          style={{
            borderRadius: radius[20],
            background: `linear-gradient(${colors.neutral10Background}),
              linear-gradient(${colors.neutralInverted100})`,
            border: `1px solid ${colors.neutral10}`,
            boxShadow: shadows.popoverLarge,
          }}
        >
          {variant === 'date' && (
            <DatePicker
              value={value}
              onChange={(value) => {
                if (value) {
                  onChange(value)
                }
              }}
              // placement={placement}
            />
          )}
          {variant === 'date-time' && (
            <DateTimePicker
              value={value}
              onChange={(value) => {
                if (value) {
                  // @ts-ignore
                  onChange(value)
                }
              }}
              selectableRange={selectableRange}
              // placement={placement}
            />
          )}
        </div>
      </Overlay.Content>
    </Overlay>
  )
}
